<vb-lxp-timing-tower-configurable
	[config]="config"
	[enableColumnCustomization]="enableColumnCustomization()"
	[hideColumnSelection]="hideColumnSelection()"
	[enableMoreColumns]="enableMoreColumns()"
	[activeClass]="activeClass()"
	[activeNumberClass]="activeNumberClass()"
	[selectedClasses]="selectedClasses()"
	(selectionAdded)="selectionAdded.emit($event)"
	(selectionRemoved)="selectionRemoved.emit($event)"
/>
